import { createSlice } from '@reduxjs/toolkit';

export const permissionSlice = createSlice({
  name: 'permission',
  initialState: {
    checkedPermission: false,
    audioDenied: false,
    audioDismissed: false,
    videoDenied: false,
    videoDismissed: false,
    cameraTaken: false,
  },
  reducers: {
    setCheckedPermission: (state, action) => {
      state.checkedPermission = action.payload;
    },
    setAudioDenied: (state, action) => {
      state.audioDenied = action.payload;
    },
    setAudioDismissed: (state, action) => {
      state.audioDismissed = action.payload;
    },
    setVideoDenied: (state, action) => {
      state.videoDenied = action.payload;
    },
    setVideoDismissed: (state, action) => {
      state.videoDismissed = action.payload;
    },
    setCameraTaken: (state, action) => {
      state.cameraTaken = action.payload;
    },
  },
});

export const {
  setCheckedPermission,
  setAudioDenied,
  setAudioDismissed,
  setVideoDenied,
  setVideoDismissed,
  setCameraTaken,
} = permissionSlice.actions;

export default permissionSlice.reducer;
